import axios from "axios";
import global from '@/global';

// Global Storage interceptor so any legacy localStorage.getItem('idcliente') reads from sessionStorage
if (typeof window !== 'undefined' && window.Storage) {
  const origGetItem = Storage.prototype.getItem;
  const CLIENT_KEYS = ['idcliente', 'id_cliente_seleccionado', 'idclient'];

  Storage.prototype.getItem = function (key) {
    if (this === window.localStorage && CLIENT_KEYS.includes(key)) {
      return (
        sessionStorage.getItem('id_cliente_seleccionado') ||
        sessionStorage.getItem('idcliente') ||
        sessionStorage.getItem('idclient') ||
        origGetItem.call(this, key)
      );
    }
    return origGetItem.call(this, key);
  };
}

axios.defaults.baseURL = global.ruta_api;
axios.defaults.imageURL = global.ruta_image;

axios.interceptors.request.use((config) => {
  let token = localStorage.getItem('token');
  config.headers = config.headers || {};

  if (localStorage.getItem('logueo') && token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  const selectedClientId =
    sessionStorage.getItem('id_cliente_seleccionado') ||
    sessionStorage.getItem('idcliente') ||
    sessionStorage.getItem('idclient') ||
    localStorage.getItem('id_cliente_seleccionado') ||
    localStorage.getItem('idcliente') ||
    localStorage.getItem('idclient');

  if (selectedClientId) {
    config.headers['X-Tenant-Id'] = selectedClientId;
  }

  return config;
}, (error) => {
  return Promise.reject(error);
});

let isRedirectingAxiosClientNotFound = false;

axios.interceptors.response.use(
  (response) => {
    const data = response?.data;
    if (data && (data.error === 'cliente_no_encontrado' || (data.status === false && data.error === 'cliente_no_encontrado'))) {
      if (!isRedirectingAxiosClientNotFound) {
        isRedirectingAxiosClientNotFound = true;
        localStorage.removeItem('idcliente');
        localStorage.removeItem('id_cliente_seleccionado');
        localStorage.removeItem('idclient');
        localStorage.removeItem('id_cliente');
        localStorage.removeItem('cliente');

        sessionStorage.removeItem('idcliente');
        sessionStorage.removeItem('id_cliente_seleccionado');
        sessionStorage.removeItem('idclient');
        sessionStorage.removeItem('id_cliente');
        sessionStorage.removeItem('cliente');

        sessionStorage.setItem(
          'tenant_offline_message',
          data.message || 'El cliente solicitado no existe en el sistema.'
        );
        window.location.href = '/seleccionarCliente';
      }
      return new Promise(() => { });
    }
    return response;
  },
  (error) => {
    const data = error.response?.data || error.data;
    if (data && (data.error === 'cliente_no_encontrado' || (data.status === false && data.error === 'cliente_no_encontrado'))) {
      if (!isRedirectingAxiosClientNotFound) {
        isRedirectingAxiosClientNotFound = true;
        localStorage.removeItem('idcliente');
        localStorage.removeItem('id_cliente_seleccionado');
        localStorage.removeItem('idclient');
        localStorage.removeItem('id_cliente');
        localStorage.removeItem('cliente');

        sessionStorage.removeItem('idcliente');
        sessionStorage.removeItem('id_cliente_seleccionado');
        sessionStorage.removeItem('idclient');
        sessionStorage.removeItem('id_cliente');
        sessionStorage.removeItem('cliente');

        sessionStorage.setItem(
          'tenant_offline_message',
          data.message || 'El cliente solicitado no existe en el sistema.'
        );
        window.location.href = '/seleccionarCliente';
      }
      return new Promise(() => { });
    }
    return Promise.reject(error);
  }
);

